export const formatLargeNumber = (value, options = {}) => {
  const { unit = '', decimals = 2 } = options;
  const number = Number(value) || 0;

  const absValue = Math.abs(number);
  let formattedValue;
  let suffix = '';

  if (absValue >= 1_000_000) {
    formattedValue = (number / 1_000_000).toFixed(decimals);
    suffix = 'M';
  } else if (absValue >= 1_000) {
    formattedValue = (number / 1_000).toFixed(decimals);
    suffix = 'K';
  } else {
    formattedValue = number.toFixed(decimals);
  }

  const normalizedValue = Number(formattedValue);
  const trimmedValue = decimals > 0
    ? normalizedValue
        .toFixed(decimals)
        .replace(/\.0+$|0+$/g, '')
        .replace(/\.$/, '')
    : Math.round(normalizedValue).toString();

  const unitPart = unit ? ` ${unit}` : '';

  return `${trimmedValue}${suffix}${unitPart}`.trim();
};

export const formatDateWithTimezone = (dateString, timezone = null) => {
  if (!dateString) return '';
  
  // CRITICAL FIX: Ensure the date string is treated as UTC
  let utcDateString = dateString;
  
  // If it doesn't have a timezone indicator, add 'Z' to force UTC interpretation
  if (typeof dateString === 'string' && 
      !dateString.endsWith('Z') && 
      !dateString.includes('+') && 
      !dateString.includes('T00:00:00')) {
    utcDateString = dateString + 'Z';
  }
  
  // If it has +00:00, convert to Z notation
  if (utcDateString.includes('+00:00')) {
    utcDateString = utcDateString.replace('+00:00', 'Z');
  }
  
  const date = new Date(utcDateString);
  
  if (isNaN(date.getTime())) {
    console.error('Invalid date:', dateString);
    return 'Invalid Date';
  }
  
  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'short'
  };
  
  if (timezone) {
    options.timeZone = timezone;
  }
  
  return new Intl.DateTimeFormat('en-US', options).format(date);
};

export const getUserTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};